import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var MethodEvent = /** @class */ (function (_super) {
    __extends(MethodEvent, _super);
    function MethodEvent(type) {
        return _super.call(this, type) || this;
    }
    MethodEvent.SHADER_INVALIDATED = 'shaderInvalidated';
    return MethodEvent;
}(EventBase));
export { MethodEvent };
